import { Checkbox, FormControl, FormLabel, Input, Text } from "@chakra-ui/react";
import { createContext, useContext, useEffect, useState } from "react";
import { CreatableSelect, Select } from "chakra-react-select";

export const EditProfileContext = createContext();

const valuesToArray = (options, values, allowMultiple) => {
  if (!values) {
    return allowMultiple ? [] : null;
  }
  if (allowMultiple) {
    return values.map((value) => ({ value, label: value }));
  } else {
    return { value: values, label: values };
  }
};

export const RedactionWarning = () => (
  <Text size="sm">
    NOTE: Here, redactions you&apos;ve make haven&apos;t been applied yet. To read through your
    awards with redactions, click <b>My Account</b> &gt; <b>Make Profile Anonymous</b>.
  </Text>
);

export const CustomInput = ({
  mt,
  label,
  name,
  as: ComponentType = Input,
  type = "text",
  ...rest
}) => {
  const { initialProfileData, update } = useEditProfileContext();
  const [value, setValue] = useState(initialProfileData[name]);
  return (
    <FormControl mt={mt}>
      <FormLabel fontWeight="bold" mb={0} pb={0}>
        {label}
      </FormLabel>
      <ComponentType
        onChange={(e) => {
          setValue(e.target.value);
          update(name, e.target.value);
        }}
        value={value}
        type={type}
        {...rest}
      />
    </FormControl>
  );
};

export const CustomSelect = ({
  label,
  mt,
  name,
  options,
  onUpdate,
  allowOther = false,
  allowMultiple = false,
  ...rest
}) => {
  const actualOptions = allowOther ? [...options, { label: "Other", value: "Other" }] : options;

  const { initialProfileData, update } = useEditProfileContext();

  const [value, setValue] = useState(initialProfileData[name]);
  // const [showOtherInput, setShowOtherInput] = useState(false)
  // const [otherValue, setOtherValue] = useState("")

  useEffect(() => {
    if (!!onUpdate) {
      onUpdate(value);
    }
  }, [value]);

  const onChange = (selected) => {
    if (Array.isArray(selected)) {
      const values = selected.map((option) => option.value);
      setValue(values);
      // const otherIndex = values.findIndex((value) => value === "Other")
      // if (allowOther) {
      //   if (otherIndex === -1) {
      update(name, values);
      // setShowOtherInput(false)
      //   } else {
      //     update(name, [...values.slice(0, otherIndex), ...values.slice(otherIndex + 1), otherValue])
      //     setShowOtherInput(true)
      //   }
      // }
    } else {
      setValue(selected.value);
      update(name, selected.value);
    }
  };

  const SelectComponent = allowOther ? CreatableSelect : Select;

  return (
    <FormControl mt={mt}>
      <FormLabel fontWeight="bold" mb={0} pb={0}>
        {label}
      </FormLabel>

      <SelectComponent
        onChange={onChange}
        isMulti={allowMultiple}
        options={actualOptions}
        value={valuesToArray(actualOptions, value, allowMultiple)}
        {...rest}
      />
      {/* {showOtherInput && (
        <Input
          onChange={(e) => {
            setOtherValue(e.target.value)
            update(name, [...value.slice(0, -1), e.target.value])
          }}
          mt={2}
          placeholder="Other Value"
        />
      )} */}
    </FormControl>
  );
};

export const CustomCheckbox = ({ label, name, onUpdate, ...rest }) => {
  const { initialProfileData, update } = useEditProfileContext();
  const [value, setValue] = useState(initialProfileData[name]);

  useEffect(() => {
    if (!!onUpdate) {
      onUpdate(value);
    }
  }, [value]);

  return (
    <Checkbox
      onChange={(e) => {
        setValue(e.target.checked);
        update(name, e.target.checked);
      }}
      isChecked={value}
      fontWeight="bold"
      {...rest}
    >
      {label}
    </Checkbox>
  );
};

export const useEditProfileContext = () => useContext(EditProfileContext);
